import axios from 'axios';

const FILE_KEY = 'file';
export default {
	getInitData(lang) {
		return axios.get(`/apps/composite/api/complaints/init/${lang}`);
	},
	uploadFile(file, sessionId) {
		let formData = new FormData();
		formData.append(FILE_KEY, file);
		return axios.post(`/apps/composite/api/complaints/fileUpload/${sessionId}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
	},
	getSettlements(zipCode) {
		return axios.get(`/apps/composite/api/complaints/settlement/${zipCode}`);
	},
	postProblemForm(data, lang) {
		return axios.post(`/apps/composite/api/complaints/submitComplaint/${lang}`, data);
	},
	postPersonalForm(data, lang) {
		return axios.post(`/apps/composite/api/complaints/submitReporter/${lang}`, data);
	},
	finalize(sessionId, lang) {
		return axios.post(`/apps/composite/api/complaints/finalize/${lang}`, sessionId, { headers: { 'Content-Type': 'text/plain' } });
	},
	deleteFile({ sessionId, fileId }) {
		return axios.delete(`/apps/composite/api/complaints/fileDelete/${sessionId}/${fileId}`);
	}
};
